import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";

//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
const routes = [
  {
    path: "/", // 中间收入达成监控大屏
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/fengtai/index.vue"),
    meta: {
      title: "丰台体育大屏",
    },
  },
  {
    path: "/map", // 中间收入达成监控大屏
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/fentaiMap/index.vue"),
    meta: {
      title: "丰台体育大屏",
    },
  },
  // {
  //   path: "/revenue-screen", // 中间收入达成监控大屏
  //   component: () =>
  //     import(/* webpackChunkName: "home" */ "@/views/revenue-screen/index.vue"),
  //   meta: {
  //     title: "宝蓝智慧园区收入大屏",
  //   },
  // },
  // {
  //   path: "/property-screen", // 智慧物业大屏
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "home" */ "@/views/property-screen/index.vue"
  //     ),
  //   meta: {
  //     title: "宝蓝智慧园区物业运营大屏",
  //   },
  // },
  // {
  //   path: "/security-screen", // 安防大屏
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "home" */ "@/views/security-screen/index.vue"
  //     ),
  //   meta: {
  //     title: "宝蓝智慧园区安防监控大屏",
  //   },
  // },
  // {
  //   path: "/fengtai", //smart-park
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "smart-park" */ "../views/smart-park/index.vue"
  //     ),
  //   meta: {
  //     title: "宝蓝智慧园区项目经营统计大屏",
  //   },
  // },
];
export default createRouter({
  history: createWebHistory(),
  routes, // `routes: routes` 的缩写
});
